import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';

export default function FeaturedPublication() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 lg:p-12">
              <span className="inline-block px-4 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 mb-4">
                Featured Report
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Climate Finance Trends in Africa 2024
              </h2>
              <p className="text-gray-600 mb-6">
                A comprehensive analysis of climate finance flows, challenges, and opportunities 
                across the African continent. This report provides key insights for policymakers, 
                investors, and development practitioners.
              </p>
              <div className="flex flex-wrap gap-4">
                <button className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-full hover:bg-green-700 transition-colors">
                  Read Report
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
                <button className="inline-flex items-center px-6 py-3 border border-green-600 text-green-600 rounded-full hover:bg-green-50 transition-colors">
                  Download PDF
                  <Download className="ml-2 h-5 w-5" />
                </button>
              </div>
            </div>
            <div className="relative h-64 lg:h-auto">
              <img
                src="https://images.unsplash.com/photo-1591696205602-2f950c417cb9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
                alt="Climate Finance Report"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}